<template>
<div class="landing-page">
  <div>
    <div style="padding-top: 100px">
      <div class="features-container">
        <div class="row align-items-center">
          <div class="col-lg-3 col-md-8 col-10 mr-auto text-left">
            <h1 class="title">Our features</h1>
            <p class="description">
              Empower your escape room business with our comprehensive suite of tools.
              From bookings to analytics, we offer everything you need to enhance operations and player experiences.</p>
            <a class="mt-3 btn btn-info btn-simple" href="/demo">
              Get a demo <i class="tim-icons el-icon-arrow-right"></i>
            </a>

          </div>
          <div class="col-lg-8 col-md-12 col-12 mt-5 mt-lg-0" >
            <div class="row">
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('bookings')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-calendar-60"></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Bookings</h4>
                  <p class="text-white description info-description" >
                    Cost-Effective Reservation System: User-friendly platform with 99% lower fees</p>
                </div>
              </div>
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('waivers')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-paper"></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Waivers</h4>
                  <p class="text-white description info-description" >
                    Customizable Legal Compliance Tools: Streamline warnings, disclaimers, and policies</p>
                </div>
              </div>
              <div style="display: inline-flex;" class="col-lg-3 col-md-3  mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('game-management')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-controller"></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Game management</h4>
                  <p class="text-white description info-description" >
                    Escape Room Performance Analytics: Optimize games, puzzles, and staff efficiency</p>
                </div>
              </div>
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('surveys')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-notes"></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Surveys</h4>
                  <p class="text-white description info-description" >
                    In-Depth Player Feedback Collection: Gather insights for continuous improvement</p>
                </div>
              </div>
            </div>
            <div class="row mt-lg-5 mt-0">
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('reporting')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-chart-bar-32" ></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Reporting and<br> analytics</h4>
                  <p class="text-white description info-description" >
                    Flexible Custom Reporting: Unlimited date ranges and data field options</p>
                </div>
              </div>
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('resource-management')">
                <div class="info text-left info-card">
                  <div class="row">
                    <div class="col">
                      <div class="icon icon-white">
                        <i class="tim-icons el-icon-user"></i>
                      </div>
                    </div>
                    <div class="col text-right">
                      <badge>coming soon</badge>
                    </div>
                  </div>
                  <h4 class="text-uppercase mt-3">Employee <br> management
                  </h4>
                  <p class="text-white description info-description" >
                    Staff Optimization Tools for scheduling and performance tracking</p>
                </div>
              </div>
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('photos')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-camera-18"></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Photos
                  </h4>
                  <p class="text-white description info-description" >
                    High-Quality Photo Capture and Sharing: One-click group distribution with custom overlays</p>
                </div>
              </div>
              <div style="display: inline-flex;" class="col-lg-3 col-md-3 mb-3 mb-lg-0 info-card-container" v-on:click="goToAnchor('checklists')">
                <div class="info text-left info-card">
                  <div class="icon icon-white">
                    <i class="tim-icons icon-check-2" ></i>
                  </div>
                  <h4 class="text-uppercase mt-3">Checklists</h4>
                  <p class="text-white description info-description" >
                    Digital Task Management: Ensure consistency in resets, cleaning, and daily operations</p>
                </div>
              </div>
<!--              <div class="col-lg-3 col-md-3 info-card-container" v-on:click="goToAnchor('integrations')">-->
<!--                <div class="info text-left info-card">-->
<!--                  <div class="icon icon-white">-->
<!--                    <i class="tim-icons icon-components"></i>-->
<!--                  </div>-->
<!--                  <h4 class="text-uppercase mt-3">&nbsp; <br>Integrations</h4>-->
<!--                  <p class="text-white description info-description" >Feature description goes here.Feature description goes here.Feature description goes here.</p>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  Bookings-->
  <section class="section mt-lg-5" id="bookings">
    <img src="/img/path4.png" class="path">
    <div class="row features-container justify-content-between">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">Bookings</h1>
        <div v-for="(f, i) in features[0].bullets" :key="'B' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[0].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[0].bullets" :key="'BS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-0"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'BSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  Waivers-->
  <section class="section" id="waivers">
<!--    <img src="/img/blob.png" class="path">-->
<!--    <img src="/img/path2.png" class="path2">-->
    <img src="/img/triunghiuri.png" class="shapes triangle">
    <img src="/img/waves.png" class="shapes wave">
<!--    <img src="/img/patrat.png" class="shapes squares">-->
<!--    <img src="/img/cercuri.png" class="shapes circle">-->
    <div class="row features-container justify-content-center">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">Waivers</h1>
        <div v-for="(f, i) in features[1].bullets" :key="'W' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[1].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[1].bullets" :key="'WS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-1"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'WSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  Game management-->
  <section class="section" id="game-management" style="margin-top: -100px">
    <img src="/img/path4.png" class="path-feature-1">
    <div class="row features-container justify-content-between">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">Game management</h1>
        <div v-for="(f, i) in features[3].bullets" :key="'B' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[3].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[3].bullets" :key="'BS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-3"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'BSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  Surveys-->
  <section class="section" id="surveys">
<!--    <img src="/img/path4.png" class="path-feature-1">-->
    <div class="row features-container justify-content-between">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">{{features[6].name}}</h1>
        <div v-for="(f, i) in features[6].bullets" :key="'B' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[6].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[6].bullets" :key="'BS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-6"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'BSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

<!--    Reporting-->
  <section class="section" id="reporting">
    <img src="/img/cercuri.png" class="shapes circle" style="margin-top: -150px;">
    <div class="row features-container justify-content-between">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">Reporting and analytics</h1>
        <div v-for="(f, i) in features[4].bullets" :key="'B' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[4].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[4].bullets" :key="'BS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-4"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'BSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  Employee management-->
  <section class="section" id="resource-management">
        <img src="/img/blob.png" class="path">
    <!--    <img src="/img/path2.png" class="path2">-->
    <!--    <img src="/img/triunghiuri.png" class="shapes triangle">-->
    <!--    <img src="/img/waves.png" class="shapes wave">-->
    <!--    <img src="/img/patrat.png" class="shapes squares">-->
<!--    <img src="/img/cercuri.png" class="shapes circle" style="margin-top: -150px; margin-left: 50px">-->
    <div class="row features-container justify-content-between">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">{{features[5].name}}</h1>
        <div v-for="(f, i) in features[5].bullets" :key="'B' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[5].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[5].bullets" :key="'BS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-5"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'BSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--  Photos-->
  <section class="section mt-lg-5" id="photos" style="margin-top: -200px">
    <!--    <img src="/img/blob.png" class="path">-->
    <!--    <img src="/img/path2.png" class="path2">-->
    <!--    <img src="/img/triunghiuri.png" class="shapes triangle">-->
    <!--    <img src="/img/waves.png" class="shapes wave">-->
    <!--    <img src="/img/patrat.png" class="shapes squares">-->
    <!--    <img src="/img/cercuri.png" class="shapes circle" style="margin-top: -150px; margin-left: 50px">-->
    <div class="row features-container justify-content-center">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">Photos</h1>
        <div v-for="(f, i) in features[2].bullets" :key="'P' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[2].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[2].bullets" :key="'PS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-2"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'PSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>
                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--  Checklists-->
  <section class="section mt-lg-5" id="checklists">
    <!--    <img src="/img/path4.png" class="path-feature-1">-->
    <div class="row features-container justify-content-between">
      <div class="col-lg-4">
        <h1 class="card-title text-uppercase">{{features[7].name}}</h1>
        <div v-for="(f, i) in features[7].bullets" :key="'B' + i">
          <div v-if="f.active" class="feature-button-active" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
          <div v-if="!f.active" class="feature-button" v-on:click="selectFeature(features[7].bullets, f)" >
            <i class="tim-icons el-icon-arrow-right text-white"></i> {{ f.name }}
          </div>
        </div>
      </div>
      <div class="col ml-3 mt-2">
        <div v-for="(f, i) in features[7].bullets" :key="'BS' + i">
          <div v-if="f.active">
            <b-carousel
              id="carousel-7"
              v-model="slide"
              controls
              :interval="6000"
              background="#ababab"
              style="text-shadow: 1px 1px 2px #333; background-color: inherit"
              img-width="100"
              img-height="100"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
              class="carousel text-center"
            >
              <b-carousel-slide
                style="background-color: inherit"
                v-for="(s, i) in f.children"
                :key="'BSS' + i"
              >
                <template #img>
                  <h3 class="mt-3">{{ s.name }}</h3>
                  <div class="d-flex flex-column align-items-center">
                    <div class="info info-warning">
                      <div class="card-avatar">
                        <a href="javascript:;">
                          <img class="img img-raised rounded" :src="s.img">
                        </a>
                      </div>
                    </div>

                  </div>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>

<!--    Integrations-->
<!--  <div class="mt-lg-5" >-->
<!--    <div class="container">-->
<!--      <section class="section" id="integrations" style="margin-top: -100px">-->
<!--        <div class="row features-container justify-content-center">-->
<!--          <div class="col-md-8 col-12">-->
<!--            <div class="pl-md-5">-->
<!--              <h1 class="card-title text-uppercase">Integrations</h1>-->
<!--              <p style="font-size: medium">-->
<!--                <i class="tim-icons el-icon-arrow-right text-primary" ></i> We integrate with many payment processors-->
<!--              </p>-->
<!--              <p style="font-size: medium">-->
<!--                <i class="tim-icons el-icon-arrow-right text-primary" ></i> Marketing integrations with Google analytics and Meta Pixel-->
<!--              </p>-->
<!--              <p style="font-size: medium">-->
<!--                <i class="tim-icons el-icon-arrow-right text-primary"></i> API available-->
<!--              </p>-->

<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-md-4 mt-lg-6" >-->
<!--            <img src="/img/custom/Integration_Redo.png" alt="Circle image" class="img-fluid feature-img">-->
<!--          </div>-->
<!--        </div>-->
<!--      </section>-->
<!--    </div>-->
<!--    <div class="row" style="margin-top: -100px; margin-bottom: 100px">-->
<!--      <div class="col" >-->
<!--        <img src="/img/custom/Integrations_Redo2.png" alt="Circle image" class="img-fluid">-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</div>
</template>

<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import {BCarousel, BCarouselSlide, BListGroup, BListGroupItem} from "bootstrap-vue";
import Badge from "@/components/Badge";

export default {
  name: "Features",
  components: {
    BListGroupItem, BListGroup, BCarousel, BCarouselSlide, TabPane, Tabs, Collapse, CollapseItem, Badge
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      features: [
        {
          "name": "Bookings",
          "bullets": [
            {
              "name": "Customizable Booking Interface",
              "active": 1,
              "children": [
                {"name": "Brand-matching design with RGB color and Google Fonts support", "img": "/img/features/Customizable_Booking_Interface/Brand-matching_design_with_RGB_color_and_Google_Fonts_support.png"},
                {"name": "Personalized booking slot messages", "img": "/img/features/Customizable_Booking_Interface/Personalized_booking_slot_messages.png"},
                {"name": "Seamless website integration with optional white-labeling", "img": "/img/features/Customizable_Booking_Interface/Seamless_website_integration_with_optional_white-labeling.png"},
                {"name": "Game, event, and gift card-specific booking pages", "img": "/img/features/Customizable_Booking_Interface/Game_event_and_gift_card-specific_booking_pages.png"},
                {"name": "Pre-populated waiver links in confirmation emails", "img": "/img/features/Customizable_Booking_Interface/Pre-populated_waiver_links_in_confirmation_emails_zoomin.png"},
                {"name": "Unlimited, game-specific custom fields with configurable requirements", "img": "/img/features/Customizable_Booking_Interface/Unlimited_game-specific_custom_fields_with_configurable_requirements.png"}
              ]
            },
            {
              "name": "Dynamic Availability Management",
              "active": 0,
              "children": [
                {"name": "Automatic booking slot updates based on staff schedules", "img": "/img/features/Dynamic_Availability_Management/Automatic_booking_slot_updates_based_on_staff_schedules.png"},
                {"name": "Customizable status and customer messages tied to resource settings", "img": "/img/features/Dynamic_Availability_Management/Customizable_status_and_customer_messages_tied_to_resource_settings.png"}
              ]
            },
            {
              "name": "Enhanced Booking Features",
              "active": 0,
              "children": [
                {"name": "Multiple item purchases via \"Add to Cart\"", "img": "/img/features/Enhanced_Booking_Features/Multiple_item_purchases_via_Add_to_Cart.png"},
                {"name": "Automated, customizable emails", "img": "/img/features/Enhanced_Booking_Features/Automated_customizable_emails.png"},
                {"name": "Bulk booking and schedule management", "img": "/img/features/Enhanced_Booking_Features/Bulk_booking_and_schedule_management.png"},
                {"name": "On-demand slot configuration", "img": "/img/features/Enhanced_Booking_Features/On-demand_slot_configuration.png"}
              ]
            },
            {
              "name": "Flexible Pricing Options",
              "active": 0,
              "children": [
                {"name": "Tiered or flat pricing models", "img": "/img/features/Flexible_Pricing_Options/Tiered_or_flat_pricing_models.png"},
                {"name": "Dynamic, slot-specific pricing", "img": "/img/features/Flexible_Pricing_Options/Dynamic_slot-specific_pricing.png"},
                {"name": "Deposit functionality", "img": "/img/features/Flexible_Pricing_Options/Deposit_functionality.png"}
              ]
            },
            {
              "name": "Comprehensive Payment Solutions",
              "active": 0,
              "children": [
                {"name": "Customizable payment methods", "img": "/img/features/Comprehensive_Payment_Solutions/Customizable_payment_methods.png"},
                {"name": "Major payment gateway support", "img": "/img/features/Comprehensive_Payment_Solutions/Major_payment_gateway_support.png"},
                {"name": "Digital and physical gift cards", "img": "/img/features/Comprehensive_Payment_Solutions/Digital_and_physical_gift_cards.png"},
                {"name": "Promotion codes", "img": "/img/features/Comprehensive_Payment_Solutions/Promotion_codes.png"},
                {"name": "Configurable taxes and fees", "img": "/img/features/Comprehensive_Payment_Solutions/Configurable_taxes_and_fees.png"}
              ]
            },
            {
              "name": "Intuitive Scheduling System",
              "active": 0,
              "children": [{"name": "", "img": "/img/features/Intuitive_Scheduling_System.png"}]
            },
            {
              "name": "Comprehensive Event Logging and Reporting",
              "active": 0,
              "children": [{"name": "", "img": "/img/features/Comprehensive_Event_Logging_and_Reporting.png"}]
            },
            {
              "name": "Full Platform Integration",
              "active": 0,
              "children": [
                {"name": "Waiver synchronization", "img": "/img/features/Full_Platform_Integration/Waiver_synchronization.png"},
                {"name": "Participant photo sharing", "img": "/img/features/Full_Platform_Integration/Participant_photo_sharing.png"},
                {"name": "Survey response tracking", "img": "/img/features/Full_Platform_Integration/Survey_response_tracking.png"},
                {"name": "Customer-viewable game analytics", "img": "/img/features/Full_Platform_Integration/Customer-viewable_game_analytics.png"},
                {"name": "Game-associated checklists and resets", "img": "/img/features/Full_Platform_Integration/Game-associated_checklists_and_resets.png"}
              ]
            }
          ]
        },
        {
          "name": "Waivers",
          "bullets": [
            {
              "name": "Customizable Design and Setup",
              "active": 1,
              "children": [
                {"name": "Brand-matching interface with RGB color and Google Fonts support", "img": "/img/features/Customizable_Design_and_Setup/Brand-matching_interface_with_RGB_color_and_Google_Fonts_support.png"},
                {"name": "Tailored data fields for streamlined check-in", "img": "/img/features/Customizable_Design_and_Setup/Tailored_data_fields_for_streamlined_check-in.png"}
              ]
            },
            {
              "name": "Seamless Booking Integration",
              "active": 0,
              "children": [
                {"name": "Automatic synchronization with booking times", "img": "/img/features/Seamless_Booking_Integration/Automatic_synchronization_with_booking_times.png"},
                {"name": "Multi-event simultaneous check-in capability", "img": "/img/features/Seamless_Booking_Integration/Multi-event_simultaneous_check-in_capability.png"}
              ]
            },
            {
              "name": "Comprehensive Data Management",
              "active": 0,
              "children": [
                {"name": "Permanent waiver storage", "img": "/img/features/Comprehensive_Data_Management/Permanent_waiver_storage.png"},
                {"name": "Intuitive filtering and reporting tools", "img": "/img/features/Comprehensive_Data_Management/Intuitive_filtering_and_reporting_tools.png"}
              ]
            },
            {
              "name": "Efficient Check-in Process",
              "active": 0,
              "children": [
                {"name": "Waivers automatically included in booking emails", "img": "/img/features/Efficient_Check-in_Process/Waivers_automatically_included_in_booking_emails.png"},
                {"name": "QR code generation for quick scanning", "img": "/img/features/Efficient_Check-in_Process/QR_code_generation_for_quick_scanning.png"}
              ]
            },
            {
              "name": "Platform-wide Integration",
              "active": 0,
              "children": [
                {"name": "Connected to bookings, transactions, game management, customers, and photos", "img": "/img/features/Platform-wide_Integration/Connected_to_bookings_transactions_game_management_customers_and_photos.png"},
                {"name": "Enhanced customer service accessibility", "img": "/img/features/Platform-wide_Integration/Enhanced_customer_service_accessibility.png"}
              ]
            }
          ]
        },
        {
          "name": "Photos",
          "bullets": [
            {
              "name": "High-Quality Image Retention",
              "active": 1,
              "children": [
                {"name": "Uncompressed storage preserves original image quality", "img": "/img/features/High-Quality_Image_Retention/Uncompressed_storage_preserves_original_image_quality.png"},
                {"name": "Memorable game experiences captured in full detail", "img": "/img/features/High-Quality_Image_Retention/Memorable_game_experiences_captured_in_full_detail.png"}
              ]
            },
            {
              "name": "Customizable Overlays",
              "active": 0,
              "children": [
                {"name": "Built-in template creator for branded photo enhancement", "img": "/img/features/Customizable_Overlays/Built-in_template_creator_for_branded_photo_enhancement.png"},
                {"name": "Game data integration for automatic information inclusion", "img": "/img/features/Customizable_Overlays/Game_data_integration_for_automatic_information_inclusion.png"},
                {"name": "Unlimited overlay options", "img": "/img/features/Customizable_Overlays/Unlimited_overlay_options.png"}
              ]
            },
            {
              "name": "Efficient Distribution",
              "active": 0,
              "children": [
                {"name": "One-click sending to all game participants", "img": "/img/features/Efficient_Distribution/One-click_sending_to_all_game_participants.png"},
                {"name": "Integration with bookings, game management, and waivers", "img": "/img/features/Efficient_Distribution/Integration_with_bookings_game_management_and_waivers.png"}
              ]
            },
            {
              "name": "Unlimited Cloud Storage",
              "active": 0,
              "children": [
                {"name": "Long-term accessibility for all customer photos", "img": "/img/features/Unlimited_Cloud_Storage/Long-term_accessibility_for_all_customer_photos.png"}
              ]
            },
            {
              "name": "Secure Automatic Uploading",
              "active": 0,
              "children": [
                {"name": "Direct storage on OTC platform, not on local devices", "img": "/img/features/Secure_Automatic_Uploading/Direct_storage_on_OTC_platform_not_on_local_devices.png"},
                {"name": "Ensures data security and user convenience", "img": "/img/features/Secure_Automatic_Uploading/Ensures_data_security_and_user_convenience.png"}
              ]
            }
          ]
        },
        {
          "name": "Game management",
          "bullets": [
            {
              "name": "Comprehensive Game Master Workflow",
              "active": 1,
              "children": [
                {
                  "name": "Track key metrics throughout the game experience",
                  "img": "/img/features/Comprehensive_Game_Master_Workflow/Track_key_metrics_throughout_the_game_experience.png"
                },
                {
                  "name": "Monitor start times, completion rates, puzzle durations, hint usage",
                  "img": "/img/features/Comprehensive_Game_Master_Workflow/Monitor_start_times_completion_rates_puzzle_durations_hint_usage.png"
                },
                {
                  "name": "Segment data by group size, demographics, and skill level",
                  "img": "/img/features/Comprehensive_Game_Master_Workflow/Segment_data_by_group_size_demographics_and_skill_level.png"
                }
              ]
            },
            {
              "name": "Data-Driven Business Insights",
              "active": 0,
              "children": [
                {
                  "name": "Analyze performance trends for game improvements",
                  "img": "/img/features/Data-Driven_Business_Insights/Analyze_performance_trends_for_game_improvements.png"
                },
                {
                  "name": "Inform strategic decisions based on player data",
                  "img": "/img/features/Data-Driven_Business_Insights/Inform_strategic_decisions_based_on_player_data.png"
                }
              ]
            },
            {
              "name": "Customer Performance Feedback",
              "active": 0,
              "children": [
                {
                  "name": "Provide players with personalized game statistics",
                  "img": "/img/features/Customer_Performance_Feedback/Provide_players_with_personalized_game_statistics.png"
                },
                {
                  "name": "Offer comparative analytics against other teams",
                  "img": "/img/features/Customer_Performance_Feedback/Offer_comparative_analytics_against_other_teams.png"
                }
              ]
            },
            {
              "name": "Integrated Web-Based Hint System",
              "active": 0,
              "children": [
                {
                  "name": "Customizable hints in text, audio, and video formats",
                  "img": "/img/features/Integrated_Web-Based_Hint_System/Customizable_hints_in_text_audio_and_video_formats.png"
                },
                {
                  "name": "Adaptive player progression support",
                  "img": "/img/features/Integrated_Web-Based_Hint_System/Adaptive_player_progression_support.png"
                }
              ]
            },
            {
              "name": "Enhanced Game Experience",
              "active": 0,
              "children": [
                {
                  "name": "Seamless integration of story videos and background music",
                  "img": "/img/features/Enhanced_Game_Experience/Seamless_integration_of_story_videos_and_background_music.png"
                },
                {
                  "name": "Tools for intro and outro video management",
                  "img": "/img/features/Enhanced_Game_Experience/Tools_for_intro_and_outro_video_management.png"
                }
              ]
            }
          ]
        },
        {
          "name": "Reporting and analytics",
          "bullets": [
            {
              "name": "Customizable Reports",
              "active": 1,
              "children": [
                {
                  "name": "Select and save your preferred data fields. Run reports on demand with your chosen parameters.",
                  "img": "/img/features/Customizable_Reports_Select_and_save_your_preferred_data_fields_Run_reports_on_demand_with_your_chosen_parameters.png"
                }
              ]
            },
            {
              "name": "Comprehensive Data Access",
              "active": 0,
              "children": [
                {
                  "name": "Generate unlimited full reports across any time period. All historical data is stored and accessible within seconds.",
                  "img": "/img/features/Comprehensive_Data_Access_Generate_unlimited_full_reports_across_any_time_period_All_historical_data_is_stored_and_accessible_within_seconds.png"
                }
              ]
            },
            {
              "name": "Adaptive Dashboards",
              "active": 0,
              "children": [
                {
                  "name": "Create personalized dashboards featuring interactive charts and graphs. Visualize key metrics over configurable time ranges for instant insights.",
                  "img": "/img/features/Adaptive_Dashboards_Create_personalized_dashboards_featuring_interactive_charts_and_graphs_Visualize_key_metrics_over_configurable_time_ranges_for_instant_insights.png"
                }
              ]
            },
            {
              "name": "Efficient Data Export",
              "active": 0,
              "children": [
                {
                  "name": "Download tables of key data points with a single click for easy analysis and sharing",
                  "img": "/img/features/Efficient_Data_Export_Download_tables_of_key_data_points_with_a_single_click_for_easy_analysis_and_sharing.png"
                }
              ]
            }
          ]
        },
        {
          "name": "Employee management",
          "bullets": [
            {
              "name": "Unlimited User Accounts",
              "active": 1,
              "children": [
                {
                  "name": "",
                  "img": "/img/features/Unlimited_User_Accounts.png"
                }
              ]
            },
            {
              "name": "Role-Based Access Control",
              "active": 0,
              "children": [
                {
                  "name": "Granular feature customization",
                  "img": "/img/features/Role-Based_Access_Control/Granular_feature_customization.png"
                },
                {
                  "name": "Role-specific notifications",
                  "img": "/img/features/Role-Based_Access_Control/Role-specific_notifications.png"
                },
                {
                  "name": "Unlimited role creation",
                  "img": "/img/features/Role-Based_Access_Control/Unlimited_role_creation.png"
                }
              ]
            },
            {
              "name": "Comprehensive User Activity Logging",
              "active": 0,
              "children": [
                {
                  "name": "",
                  "img": "/img/features/Comprehensive_User_Activity_Logging.png"
                }
              ]
            },
            {
              "name": "Employee Analytics (Coming Q2 2025)",
              "active": 0,
              "children": [
                {
                  "name": "Performance Metrics: Compare individual, team, and global benchmarks",
                  "img": "/img/features/underconstruction.png"
                },
                {
                  "name": "Integrated Evaluation: Combine data from games, checklists, and surveys",
                  "img": "/img/features/underconstruction.png"
                },
                {
                  "name": "Activity Tracking: Monitor key performance indicators",
                  "img": "/img/features/underconstruction.png"
                },
                {
                  "name": "Data-Driven Decisions: Leverage performance trends for workforce management",
                  "img": "/img/features/underconstruction.png"
                }
              ]
            },
            {
              "name": "Employee Scheduling and Time Tracking (Coming Q2 2025)",
              "active": 0,
              "children": [
                {
                  "name": "",
                  "img": "/img/features/underconstruction.png"
                }
              ]
            }
          ]
        },
        {
          "name": "Surveys",
          "bullets": [
            {
              "name": "Unlimited, customizable templates",
              "active": 1,
              "children": [
                {
                  "name": "Brand-matching design, personalized messages",
                  "img": "/img/features/Unlimited_customizable_templates_Brand-matching_design_personalized_messages.png"
                }
              ]
            },
            {
              "name": "Flexible field options",
              "active": 0,
              "children": [
                {
                  "name": "Dropdowns, checkboxes, inputs, ratings",
                  "img": "/img/features/Flexible_field_options_Dropdowns_checkboxes_inputs_ratings.png"
                }
              ]
            },
            {
              "name": "Versatile deployment",
              "active": 0,
              "children": [
                {
                  "name": "On-demand, pay-as-you-go model",
                  "img": "/img/features/underconstruction.png"
                },
                {
                  "name": "Targeted audience selection: By customer list, event, or date range",
                  "img": "/img/features/Versatile_deployment/Targeted_audience_selection_By_customer_list_event_or_date_range.png"
                },
                {
                  "name": "Automated post-event distribution",
                  "img": "/img/features/Versatile_deployment/Automated_post-event_distribution.png"
                }
              ]
            },
            {
              "name": "Comprehensive analytics",
              "active": 0,
              "children": [
                {
                  "name": "Aggregated overview, question-specific and individual responses",
                  "img": "/img/features/Comprehensive_analytics_Aggregated_overview_question-specific_and_individual_responses.png"
                }
              ]
            },
            {
              "name": "Integration",
              "active": 0,
              "children": [
                {
                  "name": "Link surveys to specific games and game masters",
                  "img": "/img/features/Integration_Link_surveys_to_specific_games_and_game_masters.png"
                }
              ]
            },
            {
              "name": "Lifetime storage of all survey responses",
              "active": 0,
              "children": [
                {
                  "name": "",
                  "img": "/img/features/Lifetime_storage_of_all_survey_responses.png"
                }
              ]
            }
          ]
        },
        {
          "name": "Checklists",
          "bullets": [
            {
              "name": "Unlimited, customizable templates",
              "active": 1,
              "children": [
                {
                  "name": "No step limit, optional/mandatory steps, game-specific mapping",
                  "img": "/img/features/Unlimited_customizable_templates_No_step_limit_optional_mandatory_steps_game-specific_mapping.png"
                }
              ]
            },
            {
              "name": "Visual step guidance",
              "active": 0,
              "children": [
                {
                  "name": "Add images to detail each step",
                  "img": "/img/features/Visual_step_guidance_Add_images_to_detail_each_step.png"
                }
              ]
            },
            {
              "name": "Staff-management communication",
              "active": 0,
              "children": [
                {
                  "name": "Notes for commentary and feedback",
                  "img": "/img/features/underconstruction.png"
                },
                {
                  "name": "Flag checklists for review or issue resolution",
                  "img": "/img/features/underconstruction.png"
                }
              ]
            },
            {
              "name": "Comprehensive analytics",
              "active": 0,
              "children": [
                {
                  "name": "Time tracking: Individual steps and overall completion",
                  "img": "/img/features/underconstruction.png"
                },
                {
                  "name": "Performance evaluation: Compare to baselines, identify areas for improvement",
                  "img": "/img/features/underconstruction.png"
                }
              ]
            },
            {
              "name": "Permanent data storage",
              "active": 0,
              "children": [
                {
                  "name": "Long-term analysis and complete activity history",
                  "img": "/img/features/Permanent_data_storage_Long-term_analysis_and_complete_activity_history.png"
                }
              ]
            }
          ]
        }
      ]
    };
  },
  methods: {
    selectFeature(array, feature){
      for(let n in array){
        array[n].active = 0
      }
      feature.active = 1
    },
    goToLink(path){
      window.location.href = '/' + path;
    },
    goToAnchor(anchor){
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    }
  }
}
</script>

<style scoped>
.feature-button{
  font-size: medium;
  width: 100%;
  background-color: #222a42;
  margin-bottom: 10px;
  color: white;
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  cursor: pointer;
  z-index: 10 !important;
  position: relative;
}

.feature-button-active{
  font-size: medium;
  width: 100%;
  box-shadow: 0 0 20px rgba(66, 184, 131, 0.47);
  background-color: #42b883;
  margin-bottom: 10px;
  color: white;
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  cursor: pointer;
  z-index: 10 !important;
  position: relative;
}

.info-card{
  padding: 20px 20px 20px 20px;
  border-radius: 5px;
  cursor: pointer;
  background-color: rgba(69, 69, 129, 0.39);
}
.info-card-container :hover{
  background-color: #e14eca;
  /*transition: all 300ms ease 0s;*/
  box-shadow: 0 0 30px rgba(225, 78, 202, 0.68);
}
.info-description{
  padding: 0 0 0 0;
}

@media (min-width: 1024px) {
  .features-container{
    margin-left: 150px;
    margin-right: 150px
  }
  .feature-img {
    margin-top: -50px;
  }
}

@media (max-width: 768px) {
  .features-container{
    margin-left: 25px;
    margin-right: 25px
  }
  .feature-img {
    margin-top: 50px;
  }
  .section{
    margin-top: -200px
  }
}

</style>
